import { CreateTeam, Privacy, Rules, Terms, TransferSummary } from "./Importer";
import { SelectCaptain } from "./Importer";
import { SaveTeamName } from "./Importer";
import { SaveTeam } from "./Importer";
import { Leagues } from "./Importer";
import { LeagueSettings } from "./Importer";
import { PublicLeaderBoard } from "./Importer";
import { LeagueLeaderBoard } from "./Importer";
import { ViewOthersTeam } from "./Importer";
import { ManageTeam } from "./Importer";
import config from "./config";
import { MyTeam } from "./Importer";
import { Home } from "./Importer";
import { Stats } from "./Importer";
import { Profile } from "./Importer";

const data = [
  {
    name: "home",
    namecompare: "home",
    title: "home",
    path: config.BASE_DOMAIN_LANG + "home",
    group: "home",
    component: Home,
    isAuthRequired: false,
    isTeamReq: false,
    fallbackName: "Home",
    isTabMenu: true,
    loadWODep: false,
    isStandAlone: true,
    isCommonPage: true,
    isSubMenu: false,
  },
  {
    name: "create-team",
    namecompare: "create-team",
    title: "create-team",
    path: config.BASE_DOMAIN_LANG + "create-team",
    group: "create-team",
    component: CreateTeam,
    isAuthRequired: false,
    isTeamReq: false,
    fallbackName: "Create Team",
    isTabMenu: true,
    loadWODep: true,
    isStandAlone: true,
    isSubMenu: true,
    groupRoutes: ["/select-captain", "/save-team-name", "/save-team"],
  },
  {
    name: "select-captain",
    namecompare: "select-captain",
    title: "select-captain",
    path: config.BASE_DOMAIN_LANG + "select-captain",
    group: "create-team",
    component: SelectCaptain,
    isAuthRequired: false,
    isTeamReq: false,
    fallbackName: "Select Captain",
    isTabMenu: false,
    isSubMenu: false,
    routes: [
      {
        path: config.BASE_DOMAIN_LANG + "select-captain/lateonboarding",
        component: SelectCaptain,
      },
    ],
    loadWODep: true,
  },
  {
    name: "save-team-name",
    namecompare: "save-team-name",
    title: "save-team-name",
    path: config.BASE_DOMAIN_LANG + "save-team-name",
    group: "create-team",
    component: SaveTeamName,
    isAuthRequired: false,
    isTeamReq: false,
    fallbackName: "Save Team Name",
    isTabMenu: false,
    loadWODep: true,
    isSubMenu: false,
  },
  {
    name: "save-team",
    namecompare: "save-team",
    title: "save-team",
    path: config.BASE_DOMAIN_LANG + "save-team",
    group: "create-team",
    component: SaveTeam,
    isAuthRequired: false,
    isTeamReq: false,
    fallbackName: "Save Team",
    isTabMenu: false,
    loadWODep: true,
    isSubMenu: false,
  },
  {
    name: "my-team",
    namecompare: "my-team",
    title: "my-team",
    path: config.BASE_DOMAIN_LANG + "my-team/:mDID?",
    pathroute: config.BASE_DOMAIN_LANG + "my-team",
    group: "manage-team",
    component: MyTeam,
    isAuthRequired: true,
    isTeamReq: true,
    fallbackName: "My Team",
    isTabMenu: true,
    groupRoutes: [config.BASE_DOMAIN_LANG + "manage-team"],
    loadWODep: false,
    isStandAlone: true,
    isSubMenu: false,
  },
  {
    name: "manage-team",
    namecompare: "manage-team",
    title: "manage-team",
    path: config.BASE_DOMAIN_LANG + "manage-team",
    group: "manage-team",
    component: ManageTeam,
    isAuthRequired: true,
    isTeamReq: true,
    fallbackName: "Manage Team",
    isTabMenu: false,
    loadWODep: false,
    isStandAlone: false,
    isSubMenu: false,
  },
  {
    name: "transfer-summary",
    namecompare: "transfer-summary",
    title: "transfer-summary",
    path: config.BASE_DOMAIN_LANG + "transfer-summary",
    group: "manage-team",
    component: TransferSummary,
    isAuthRequired: true,
    isTeamReq: true,
    fallbackName: "Transfer Summary",
    isTabMenu: false,
    loadWODep: false,
    isStandAlone: false,
    isSubMenu: true,
  },
  {
    name: "leagues",
    namecompare: "leagues",
    title: "leagues",
    pathroute: config.BASE_DOMAIN_LANG + "leagues",
    path:
      config.BASE_DOMAIN_LANG + "leagues/:leagueCode?/:leagueName?/:userName?",
    group: "league",
    component: Leagues,
    isAuthRequired: true,
    isTeamReq: true,
    fallbackName: "Leagues",
    isTabMenu: true,
    loadWODep: true,
    isStandAlone: true,
    isSubMenu: false,
    groupRoutes: [
      config.BASE_DOMAIN_LANG + "league-leaderboard/:leagueID",
      config.BASE_DOMAIN_LANG + "public-leaderboard/:TypeID/:countryID/:clubID",
      config.BASE_DOMAIN_LANG + "league-settings/:leagueID",
    ],
  },
  {
    name: "league-settings",
    namecompare: "league-settings",
    title: "league-settings",
    // toShow: false,
    // isSelected: false,
    path: config.BASE_DOMAIN_LANG + "league-settings/:leagueID",
    path_: "/league-settings",
    group: "league",
    component: LeagueSettings,
    isAuthRequired: true,
    isTeamReq: true,
    fallbackName: "League Settings",
    isTabMenu: false,
    loadWODep: true,
    isStandAlone: true,
    isSubMenu: true,
    // step: 8,
    // order: 4,
    // TrkPageTitle: 'UCL Fantasy - League Settings',
    // TrkPageFormat: 'standard view',
    // TrkPageType: 'settings',
    // TrkPageSubType: 'fantasy league',
  },
  {
    name: "public-leaderboard",
    namecompare: "public-leaderboard",
    title: "public-leaderboard",
    // toShow: false,
    // isSelected: false,
    path:
      config.BASE_DOMAIN_LANG + "public-leaderboard/:TypeID/:countryID/:clubID",
    path_: "/public-leaderboard",
    group: "league",
    component: PublicLeaderBoard,
    isAuthRequired: true,
    isTeamReq: true,
    fallbackName: "Public League Leaderboard",
    isTabMenu: false,
    loadWODep: true,
    // step: 8,
    // order: 4,
    // TrkPageTitle: 'UCL Fantasy - Public Leaderboard',
    // TrkPageFormat: 'standard view',
    // TrkPageType: 'leaderboard',
    // TrkPageSubType: 'fantasy league',
  },
  {
    name: "league-leaderboard",
    namecompare: "league-leaderboard",
    title: "league-leaderboard",
    // toShow: false,
    // isSelected: false,
    path: config.BASE_DOMAIN_LANG + "league-leaderboard/:leagueID",
    path_: "/league-leaderboard",
    group: "league",
    component: LeagueLeaderBoard,
    isAuthRequired: true,
    isTeamReq: true,
    fallbackName: "League Leaderboard",
    isTabMenu: false,
    loadWODep: true,
    // step: 8,
    // order: 4,
    // TrkPageTitle: 'UCL Fantasy - League Leaderboard',
    // TrkPageFormat: 'standard view',
    // TrkPageType: 'leaderboard',
    // TrkPageSubType: 'fantasy league',
  },
  {
    name: "view-others-team",
    namecompare: "view-others-team",
    title: "view-others-team",
    toShow: false,
    isSelected: false,
    path:
      config.BASE_DOMAIN_LANG +
      "view-others-team/:GUID/:FullName/:USID/:UsTmID/:GDID?/:PHID?",
    // /:GUID/:FULLNAME/:RANK/:GDID?/:PHID?
    // "
    // path_: '/',
    group: "view-others-team",
    component: ViewOthersTeam,
    isAuthRequired: true,
    isTeamReq: true,
    fallbackName: "View friends team",
    isTabMenu: false,
    loadWODep: true,
    isSubMenu: true,
    isStandAlone: true,
    // step: 8,
    // order: 4,
    // TrkPageTitle: 'UCL Fantasy - League Settings',
    // TrkPageFormat: 'standard view',
    // TrkPageType: 'settings',
    // TrkPageSubType: 'fantasy league',
  },
  // {
  //   name: "create-team",
  //   namecompare: "create-team",
  //   title: "create-team",
  //   path: "*",
  //   group: "create-team",
  //   component: LeagueSettings,
  // },
  {
    name: "stats",
    namecompare: "stats",
    title: "stats",
    path: config.BASE_DOMAIN_LANG + "stats",
    group: "stats",
    component: Stats,
    isAuthRequired: false,
    isTeamReq: false,
    fallbackName: "Statistics",
    isTabMenu: true,
    loadWODep: false,
    isStandAlone: true,
    isCommonPage: true,
    isSubMenu: false,
  },
  {
    name: "profile",
    namecompare: "profile",
    title: "profile",
    path: config.BASE_DOMAIN_LANG + "profile",
    group: "profile",
    component: Profile,
    isAuthRequired: true,
    isTeamReq: false,
    fallbackName: "My Profile",
    isTabMenu: false,
    loadWODep: false,
    isStandAlone: true,
    isCommonPage: false,
    isSubMenu: true,
  },
  {
    name: "rules",
    namecompare: "rules",
    title: "rules",
    path: config.BASE_DOMAIN_LANG + "rules",
    group: "static",
    component: Rules,
    isAuthRequired: false,
    isTeamReq: false,
    fallbackName: "My Rules",
    isTabMenu: true,
    loadWODep: false,
    isStandAlone: true,
    isCommonPage: true,
    isSubMenu: false,
  },
  {
    name: "terms",
    namecompare: "terms",
    title: "terms",
    path: config.BASE_DOMAIN_LANG + "terms",
    group: "static",
    component: Terms,
    isAuthRequired: false,
    isTeamReq: false,
    fallbackName: "My Terms",
    isTabMenu: true,
    loadWODep: false,
    isStandAlone: true,
    isCommonPage: true,
    isSubMenu: false,
  },
  {
    name: "privacy",
    namecompare: "privacy",
    title: "privacy",
    path: config.BASE_DOMAIN_LANG + "privacy",
    group: "static",
    component: Privacy,
    isAuthRequired: false,
    isTeamReq: false,
    fallbackName: "Privacy",
    isTabMenu: true,
    loadWODep: false,
    isStandAlone: true,
    isCommonPage: true,
    isSubMenu: false,
  },
];

export default data;

// export default data;
